import { MeteoConditionsID } from '@enums/MeteoConditionsID'
import { MeteoConditionsDTO } from './api/MeteoConditionsDTO'

export class MeteoConditions {
  id: MeteoConditionsID
  label?: string
  minValue?: number
  maxValue?: number
  values: number[]
  repeat: boolean
  ignore?: boolean
  decimals?: number

  constructor(meteoConditions: MeteoConditionsDTO) {
    this.id = meteoConditions.ID
    this.label = this.getFrontLabel()
    this.values = meteoConditions.VALORES.map((value) =>
      value.toString().includes('.') ? parseFloat(value.toFixed(2)) : value
    )
    this.decimals = meteoConditions.DECIMALES || 0
    if (meteoConditions.MAX_VALUE !== undefined) {
      this.maxValue = meteoConditions.MAX_VALUE
    }
    if (meteoConditions.MIN_VALUE !== undefined) {
      this.minValue = meteoConditions.MIN_VALUE
    }
    this.repeat = false
  }

  static fromDTO(dto: MeteoConditionsDTO): MeteoConditions {
    return new MeteoConditions(dto)
  }

  toDTO(): MeteoConditionsDTO {
    return {
      ID: this.id,
      VARIABLE: this.label || this.id,
      VALORES: this.values,
      DECIMALES: this.decimals || 0,
      MAX_VALUE: this.maxValue,
      MIN_VALUE: this.minValue,
      IGNORE: this.ignore
    }
  }

  getApexChartType() {
    return {
      [MeteoConditionsID.PRECIPITATION]: 'column',
      [MeteoConditionsID.RELATIVE_HUMIDITY]: 'line',
      [MeteoConditionsID.TEMPERATURE]: 'line',
      [MeteoConditionsID.CLOUDINESS]: 'line',
      [MeteoConditionsID.WIND_SPEED]: 'line',
      [MeteoConditionsID.WIND_DIRECTION]: 'line'
    }[this.id]
  }

  getFrontLabel() {
    return {
      [MeteoConditionsID.TEMPERATURE]: 'Temperatura (Cº)',
      [MeteoConditionsID.RELATIVE_HUMIDITY]: 'Hum. Relativa (%)',
      [MeteoConditionsID.WIND_SPEED]: 'Mod. Viento (km/h)',
      [MeteoConditionsID.WIND_DIRECTION]: 'Direc. Viento (º)',
      [MeteoConditionsID.CLOUDINESS]: 'Nubosidad (%)',
      [MeteoConditionsID.PRECIPITATION]: 'Precipitación (mm)'
    }[this.id]
  }
}
